import { PrimitiveType } from '../shared/BasicTypes';
Array.prototype.filterDuplicates = function<T extends PrimitiveType>() {
  return this.filter((item: T, index, arr: T[]) => arr.findIndex((it) => it === item) === index);
};

Array.prototype.sortOnMultipleCriteria = function<T>(
  ...comparators: Array<(firstElement: T, secondElement: T) => number>
) {
  if (!comparators || comparators.length === 0) {
    throw new Error('Please specifiy at least one comparator');
  }
  const lastIndex = comparators.length - 1;
  const ultimateComparator = comparators.reduceRight(
    (acc, curr) => (i1, i2) => (curr(i1, i2) === 0 ? acc(i1, i2) : curr(i1, i2)),
    comparators[lastIndex],
  );
  return this.sort(ultimateComparator);
};
